// Sound files
import notificationAlert from '../assets/sounds/notification-alert.wav';
import notificationGeneral from '../assets/sounds/notification-general.wav';
import notificationSuccess from '../assets/sounds/notification-success.wav';

// Sound registry - add more sounds here as needed
const sounds = {
  alert: notificationAlert,
  general: notificationGeneral,
  success: notificationSuccess,
};

// Preload audio elements for instant playback
const audioElements = {};

Object.entries(sounds).forEach(([key, src]) => {
  audioElements[key] = new Audio(src);
});

/**
 * Play a sound by name
 * @param {string} soundName - The name of the sound to play ('success', 'alert', etc.)
 * @param {number} volume - Volume level from 0 to 1 (default: 0.5)
 */
export const playSound = (soundName, volume = 0.5) => {
  const audio = audioElements[soundName];
  
  if (audio) {
    // Reset to beginning if already playing
    audio.currentTime = 0;
    audio.volume = volume;
    audio.play().catch((error) => {
      // Browser may block autoplay - this is expected on first interaction
      console.warn('Sound playback failed:', error);
    });
  } else {
    console.warn(`Sound "${soundName}" not found`);
  }
};

// Hook version if you need it in a component
export const useSound = () => {
  return { playSound };
};